import KnowledgeCenter from "../components/KnowledgeCenter";
import MediaSection from "../components/MediaSection";
import EventsSection from "../components/EventsSection";
import SocialMedia from "../components/SocialMedia";
import Footer from "../components/Footer";
import Highlighting from '../components/Highlighting';
import PillarsBar from '../components/PillarsBar';
import StickySocial from '../components/StickySocial';
import KnowledgeInitiative from '../components/KnowledgeInitiative';
import BecomeMember from '../components/BecomeMember';
import Updates from '../components/Updates';
import EventAndPodcast from '../components/EventAndPodcast';
import GrowthPillars from '../components/GrowthPillars';
import FlagshipAndEvent from '../components/FlagshipAndEvent';
import Hero from '../components/HeroSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <GrowthPillars />
        <FlagshipAndEvent />
        <KnowledgeInitiative /> 
        <BecomeMember />
        <MediaSection />
        <StickySocial />
        <Updates /> 
      </main>
    </div>
  );
};

export default Home;